import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNixosComponent } from './simple-icons-nixos.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNixosComponent ],
    exports:      [ SimpleIconsNixosComponent ],
    bootstrap:    []
})
export class SimpleIconsNixosModule {}
